<template>
  <div
    v-if="options"
    class="koc-state-country-select-block"
  >
    <div
      class="koc-state-country-select-element"
    >
      <div
        :id="state.unique + '_current'"
        :class="state.style"
        class="koc-state-country-select-element-current"
        @click="click"
      >
        <label
          v-show="state.selected && state.selected.name"
          class="koc-state-country-select-element-label"
        >{{ label }}</label>
        <div
          :id="state.unique + '_text'"
          class="koc-state-country-select-element-current-option-text"
        >
          {{ state.selected && state.selected.name ? state.selected.name : placeholder }}
        </div>
        <div
          :id="state.unique + '_caret_box'"
          class="koc-state-country-select-current-caret-box"
          :class="disabled ? 'disabled' : ''"
        >
          <font-awesome-icon
            :id="state.unique + '_caret'"
            :icon="state.optionsShown ? 'caret-up' : 'caret-down'"
            class="koc-state-country-select-dropdown-caret"
          />
        </div>
      </div>
      <ul
        v-show="state.optionsShown"
        class="koc-state-country-select-element-dropdown"
      >
        <li
          v-for="option in options"
          :key="option.id"
          :class="state.selected && state.selected.id === option.id ? 'selected' : ''"
          class="koc-state-country-select-element-dropdown-options"
          @click="select(option)"
        >
          {{ option.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script src="./form-select-state-country.js"></script>
<style lang="scss" scoped src="./form-select-state-country.scss"></style>
